export default __webpack_public_path__ + "static/media/signup-infographic.48c24166.svg";